import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  emoji: '🗓️',
  title: 'Geraubte Wochenenden',
  desc: 'Sie haben es satt, Ihre Freizeit mit Recherche für günstige Züge und Orte zu verschwenden.'
}, {
  emoji: '⚡',
  title: 'Null Energie',
  desc: 'Sie kommen nach der Arbeit erschöpft nach Hause und müssen noch den nächsten Ski-Tag planen.'
}, {
  emoji: '🔁',
  title: 'Immer das Gleiche',
  desc: 'Sie fahren immer an die gleichen 2-3 Orte und Ihre Familie fängt an, sich zu langweilen.'
}, {
  emoji: '🏆',
  title: 'Sie wollen das Beste',
  desc: 'Sie wollen Ihrer Familie ein Weltklasse-Erlebnis bieten, ohne ein Vermögen auszugeben.'
}];
export function ForYouChecklist() {
  return <section className="py-10 px-4 bg-brand-card/40 border-y border-brand-orange/10" data-id="element-109">
      <div className="max-w-xl mx-auto" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-111">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-3" data-id="element-112">
            Erkennen Sie sich wieder?
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-113">
            Diese Ressource ist für Sie, wenn...
            <br data-id="element-114" />
            Wenn Sie sich in 2 oder mehr dieser Situationen wiederfinden, sind
            Sie hier genau richtig.
          </p>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-115">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex gap-3 items-start bg-brand-dark p-4 rounded-xl border border-white/5" data-id="element-116">
              <div className="text-3xl shrink-0" data-id="element-117">{item.emoji}</div>
              <div data-id="element-118">
                <h3 className="font-bold text-brand-cream mb-0.5" data-id="element-119">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-400 leading-snug" data-id="element-120">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-base font-bold text-brand-gold" data-id="element-121">
          ✓ Dann wurde das Swiss Peak System für Sie entwickelt.
        </p>
      </div>
    </section>;
}